import { gql } from '@apollo/client';

export const UPDATE_USER = gql`
mutation UpdateUser($user: UpdateUserInput!) {
  updateUser(user: $user) {
    ... on UpdateUserSuccess {
      code
      message
    }
    ... on Error {
      code
      message
    }
  }
}`